import type { AgentApiCandidateFormsShow } from '@/types/serializers';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface CreateCandidateFormParams {
  title?: string;
  color_type?: string;
  custom_field_ids?: number[];
}

/**
 * フォーム作成用のフック
 */
export default function useCreateCandidateForm() {
  const queryClient = useQueryClient();
  const token =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '';

  return useMutation({
    mutationFn: async (params: CreateCandidateFormParams = {}) => {
      const response = await fetch('/agent/api/candidate_forms.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          candidate_form: {
            title: params.title,
            color_type: params.color_type,
            custom_field_ids: params.custom_field_ids,
          },
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.[0] || 'フォームの作成に失敗しました');
      }

      const data: AgentApiCandidateFormsShow = await response.json();
      return data;
    },
    onSuccess: () => {
      // フォーム一覧のキャッシュを無効化して再取得
      queryClient.invalidateQueries({ queryKey: ['candidate_forms'] });
    },
  });
}
